module.exports = __webpack_public_path__ + "img/profile-add.35f3e3a7.svg";